import confirmation from "app/main/confirmation/Confirmation";
import topic from "common/managers/topic";
import loginOperations from "common/datasources/login/loginOperations";
import crossTabTopic from "common/managers/crossTabTopic";

export default {

    _notifyOthers: false,

    initLogoutHandler() {
        topic.subscribe("app/logout", this.logout, this);
        this.initLogoutMessageHandler();
    },

    /**
     * This method sets this tab up to be notified when any other tab has forced a logout.
     * Override this if you don't want that.
     */
    initLogoutMessageHandler() {
        crossTabTopic.subscribe("logoutBase/logoutNotify", this.forceLogout, this);
        this._notifyOthers = false;
        crossTabTopic.subscribe("logoutBase/ack", () => {
            this._notifyOthers = true;
        });
        crossTabTopic.publish("logoutBase/hello");
        crossTabTopic.subscribe("logoutBase/hello", () => {
            crossTabTopic.publish("logoutBase/ack");
            this._notifyOthers = true;
        });
    },

    /**
     * Base Logout used when a logout has been requested somewhere inside this module.
     * By default, this will show a confirmation window, notify other windows, them ove the logged out page.
     * Override this method if that is not desired.
     */
    logout() {
        this._confirmLogout()
    },

    _confirmLogout() {
        if(this._notifyOthers) {
            confirmation.confirmLogout()
                .done((e) => {
                    if(e.logout) {
                        crossTabTopic.publish("logoutBase/logoutNotify");
                    }
                });
        } else {
            this.forceLogout();
        }
    },


    forceLogout() {
        topic.publish("app/logoutImminent");
        loginOperations.logout();
    },
}
